import * as Sentry from '@sentry/browser'
import { Announce } from '@/interfaces/announce'
import { API_BASE_URL, X_API_KEY } from './api'
import CookieManager from '../src/lib/CookiesManager'

export interface Practice {
  id: number
  practiceName: string
  practiceCategoryId: number
}

export interface PracticeCategory {
  id: number
  categoryName: string
  practices: Practice[]
}

export interface PracticeResponse {
  practiceList: PracticeCategory[]
}

const fetchWithHeaders = async (url: string, method: string = 'GET') => {
  const response = await fetch(`${API_BASE_URL}${url}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${CookieManager.getToken()}`,
      'x-api-key': X_API_KEY,
    },
  })

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`)
  }

  return response.json()
}

export const fetchPractices = async (): Promise<PracticeCategory[]> => {
  try {
    const data: PracticeResponse = await fetchWithHeaders('/practices')
    return data.practiceList
  } catch (error) {
    console.error('Error fetching practices:', error)
    throw error
  }
}

export const fetchAnnouncess = async (): Promise<Announce[]> => {
  try {
    const data = await fetchWithHeaders('/all/full')

    let announces: Announce[] = []

    if (data?.users) {
      announces = data.users
        .filter((user: any) => user.announce !== null)
        .map((user: any) => user.announce)
    }

    return announces
  } catch (error) {
    console.error('Error fetching announces:', error)
    throw error
  }
}

export const fetchPracticesByCategory = async (
  categoryName: string,
): Promise<string[]> => {
  try {
    const practiceCategories = await fetchPractices()
    const category = practiceCategories.find(
      category => category.categoryName === categoryName,
    )
    if (!category) {
      return []
    }
    return category.practices.map(practice => practice.practiceName)
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'fetchPracticesByCategory',
        categoryName,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'fetchPracticesByCategory',
      },
    })
    throw error
  }
}
